// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wdoJ","colMin":"styles_colMin__13SBD"};